<app-base-list-wrapper [baseListComponent]="this" />
<ng-template #actionButtonTemplate let-navigate="navigate" let-navigateInNewTab="navigateInNewTab">
    <div class="flex gap-1">
        <p-button icon="fa fa-eye" [text]="true" severity="secondary" (onClick)="navigate()" [pTooltip]="'common.view' | translate"></p-button>
        <p-button icon="fa fa-external-link-alt" [text]="true" severity="secondary" (onClick)="navigateInNewTab()" [pTooltip]="'common.open-in-new-tab' | translate"></p-button>
    </div>
</ng-template>
